import WhatsAppEnquiryForm from "@/components/feature/WhatsAppEnquiryForm";

export default function ContactMainLayout() {
  return (
    <section id="enquiry-form" className="py-16 md:py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          {/* Left: Office Info + Map */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-[#EAF5E1] px-3 py-1.5 rounded-full mb-4">Find Us</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Visit Our Office</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-7" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Our Bengaluru office is open daily. Walk in for a consultation, or schedule a free site visit to any of our residential projects on Sarjapur Road.
            </p>

            <div className="flex flex-col gap-4 mb-7">
              {[
                { icon: "ri-map-pin-2-fill", label: "Office", value: "#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road, Bangalore – 562125" },
                { icon: "ri-phone-fill", label: "Phone", value: "+91 99451 24133 | 080 27822444", href: "tel:+919945124133" },
                { icon: "ri-mail-fill", label: "Email", value: "sales@urbaninfraproject.in", href: "mailto:sales@urbaninfraproject.in" },
                { icon: "ri-time-fill", label: "Hours", value: "11:00 AM – 7:00 PM" },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#7FBF3F] text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">{item.label}</p>
                    {(item as { href?: string }).href ? (
                      <a href={(item as { href: string }).href} className="text-gray-700 text-sm leading-relaxed hover:text-[#2E7D32] transition-colors cursor-pointer">{item.value}</a>
                    ) : (
                      <p className="text-gray-700 text-sm leading-relaxed">{item.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Map Section */}
            <div className="mb-2">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                  <i className="ri-map-2-line text-[#7FBF3F] text-sm"></i>
                </div>
                <span className="text-sm font-semibold text-[#212121] tracking-wide">Find Us on Map</span>
              </div>
              <div className="rounded-2xl overflow-hidden border border-[#7FBF3F]/15" style={{ height: "280px" }}>
                <iframe
                  title="Urban Infra Projects Office - VPPQ+H8 Bengaluru"
                  src="https://maps.google.com/maps?q=VPPQ%2BH8+Bengaluru,+Karnataka&t=&z=17&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <a
                href="https://maps.app.goo.gl/Nw8RvpZjMwLjBbhh8?g_st=ic"
                target="_blank"
                rel="nofollow noreferrer"
                className="mt-3 w-full flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-fill"></i>
                Get Directions
              </a>
            </div>
          </div>

          {/* Right: WhatsApp Form */}
          <div>
            <WhatsAppEnquiryForm />
          </div>
        </div>
      </div>
    </section>
  );
}
